
























// Composition
import { defineComponent } from '@vue/composition-api'
import { storeToRefs } from 'pinia'

// Store
import { useSearchStore } from '@/store/search'

// componenents
import Facets from '@/components/feature/search/facets/Facets.vue'
import FacetLegend from '@/components/feature/search/facets/FacetLegend.vue'
import ResultsList from '@/components/feature/search/results/ResultsList.vue'
import Navbar from '@/components/feature/search/nav/Navbar.vue'
import FacetsApplied from '@/components/feature/search/facets/FacetsApplied.vue'
import SearchResultsPerPage from '@/components/feature/search/nav/SearchResultsPerPage.vue'
import SearchPagination from '@/components/feature/search/nav/SearchPagination.vue'
import NoResults from '@/components/feature/search/results/NoResults.vue'

export default defineComponent({
  components: {
    Facets,
    FacetLegend,
    Navbar,
    FacetsApplied,
    ResultsList,
    SearchResultsPerPage,
    SearchPagination,
    NoResults,
  },

  setup() {
    const { ui, hasProductResults } = storeToRefs(useSearchStore())

    return {
      ui,
      hasProductResults,
    }
  },
})
